import React, { useEffect, useState } from "react";
import notificationSocketConnection from "../sockets/notification.socket";
import { generateToken, getDataFromStorage } from "../libs/auth.helper";
import useConfig from "../hooks/use-config";
let notificationSocket = null;
const SocketContext = React.createContext({
    socket: null,
    initialNotification: () => {
    },
    isConnectionFailed: false
});
export const SocketContextProvider = (props) => {
    const [socket, setSocket] = useState(null);
    const config = useConfig();
    const [isConnectionFailed, setIsConnectionFailed] = useState(false);
    console.log("V2.4");
    const fireAuthentication = () => new Promise((resolve) => generateToken().then((token) => {
        const authData = {
            user_id: parseInt(getDataFromStorage().userInfo.id || ''),
            token: token,
            platform: getDataFromStorage().audience,
            country: getDataFromStorage().country,
            lang: config.lang,
        };
        notificationSocket.emit('authentication', authData, function (...data) {
            console.log(data, 'res');
            resolve(true);
            setIsConnectionFailed(false);
        });
    }));
    const initialNotification = () => {
        return new Promise((resolve) => generateToken().then((token) => {
            notificationSocket = notificationSocketConnection(config.urls.gulpin2);
            // notificationSocket.on('reconnect', function () {
            //     setSocket(null)
            //     fireAuthentication().then(() => {
            //         console.log('reconnect auth')
            //         setSocket(notificationSocket)
            //     })
            // })
            notificationSocket.on("connect", function () {
                setSocket(null);
                fireAuthentication().then(() => {
                    console.log('reconnect auth');
                    setSocket(notificationSocket);
                });
            });
            notificationSocket === null || notificationSocket === void 0 ? void 0 : notificationSocket.on('disconnect', function (err) {
                setSocket(null);
            });
            notificationSocket.on('error', function (err) {
                setSocket(null);
                setIsConnectionFailed(true);
            });
            notificationSocket.on("connect_error", function () {
                console.log('connect_error');
                setSocket(null);
                // setTimeout(() => {
                //     console.log('try to connect')
                //     notificationSocket.io.reconnect()
                // }, 2000)
            });
        }));
    };
    useEffect(() => {
        if (socket)
            return;
        console.log("connect 2");
        if (notificationSocket && notificationSocket.connected)
            notificationSocket.disconnect();
        notificationSocket = null;
        initialNotification().then((socket) => {
            setSocket(socket);
        });
        return () => {
            console.log('clean up temp socket');
            notificationSocket === null || notificationSocket === void 0 ? void 0 : notificationSocket.off('connect');
            notificationSocket === null || notificationSocket === void 0 ? void 0 : notificationSocket.off('disconnect');
            socket === null || socket === void 0 ? void 0 : socket.disconnect();
        };
    }, [socket]);
    useEffect(() => {
        if (!socket)
            return;
        return () => {
            console.log('clean up socket');
            socket === null || socket === void 0 ? void 0 : socket.off('connect');
            socket === null || socket === void 0 ? void 0 : socket.off('disconnect');
        };
    }, [socket]);
    return (React.createElement(SocketContext.Provider, { value: {
            socket,
            initialNotification,
            isConnectionFailed
        } }, props.children));
};
export default SocketContext;
